import { IArrival } from './arrival';

/**
 * 推奨発注を持つオブジェクトのインターフェース
 * @property recommend - 推奨発注
 */
interface IHasRecommendOrders {
  recommend: IArrival[];
}

const orderProperties = [
  // aggregator.tsで利用する
  'recommend',
] as const;

/**
 * オブジェクトが発注情報かどうかを明確にする
 * @param value - 指定された発注オブジェクト
 */
function isIHasRecommendOrders(value: object): value is IHasRecommendOrders {
  /*TODO: IOrderが持つべきものを明確にする */
  return true;
}

/**
 * アラートの種類
 * OrderAmountWarning: 発注数量警告
 * DeliveryDateWarning: 納期警告
 * DeliveryDateInfo: 納期情報
 * DeliveryDateConfirmedInfo: 納期確定情報
 */
type AlertType = 'OrderAmountWarning' | 'DeliveryDateWarning' | 'DeliveryDateInfo' | 'DeliveryDateConfirmedInfo';

export type { IHasRecommendOrders as IOrder, AlertType };
export { orderProperties, isIHasRecommendOrders as isIOrder };
